import AssignTrainingFormnew from "../../components/Forms/AssignTrainingFormnew";
import MainSkills from "../../components/Forms/MainSkills";
import BasicCard from "../../pages/BasicCard";
import Dummylayout from "../../pages/Dummylayout";
import AssignTrainingForm from "./AssignTrainingForm";


function AssignTraining() {
    return (
        <>
            <Dummylayout/>
            <BasicCard>
                <AssignTrainingFormnew/>
            </BasicCard>
        </>
    )
}
export default AssignTraining;